import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';

import { API_URL } from '../constants/api';
import { ENDPOINTS } from '../constants/api';
import { getToken, decodeToken } from '../utils/TokenUtils';
import DetailData from './DetailData';
import { useTranslation } from 'react-i18next';
import CustomerCareDashboard from './CustomerCareDashboard';
import CustomerPortalDashbpard from './CustomerPortalDashbpard';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function Charts() {
  const token = getToken();
  const { t } = useTranslation();
  const [stats, setStats] = useState([]);
  const [salesData, setSalesData] = useState(null);
  const [loadingChart, setLoadingChart] = useState(true);

  const userType = decodeToken(token, 'userLevel');

  const [selectedId, setSelectedId] = useState(null);
  const [chartTitle, setChartTitle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const allowedUserTypes = [
    'eng_development',
    'customer_care',
    'eng_customer_care',
    'admin',
    'developer',
  ];
const isSamaCompany =
  API_URL.includes('samacompany') || API_URL.includes('gure');
  const isAllowedAPI = API_URL === 'https://newktcapi.kaafi.net';
  const isAllowedUser = allowedUserTypes.includes(userType);

  const openModal = (id, title) => {
    setSelectedId(id);
    setChartTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedId(0);
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchCharts = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/get-charts`,
          { headers: { Authorization: token ? `Bearer ${token}` : '' } }
        );
        setStats(response.data);
      } catch (error) {
        console.log('Error fetching stats:', error.message);
        setStats([]);
      }
    };
    fetchCharts();
  }, []);
const getMonthTitle = () => {
  const now = new Date();
  return now.toLocaleString('default', { month: 'long', year: 'numeric' });
};

  useEffect(() => {
  if (!isSamaCompany) {
    setLoadingChart(false);
    return;
  }
    const fetchSalesByProduct = async () => {
      setLoadingChart(true);
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/sales-by-product`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const report = response.data.report;
        setSalesData({
          labels: report.map((item) => item.product),
          datasets: [
            {
              label: 'Total Sales',
              data: report.map((item) => item.total),
              backgroundColor: '#F0801C',
              borderRadius: 4,
              borderSkipped: false,
            },
          ],
        });
      } catch (err) {
        console.log('Error fetching sales by product:', err.message);
        setSalesData(null);
      } finally {
        setLoadingChart(false);
      }
    };
    fetchSalesByProduct();
  }, []);

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => ' KSh ' + ctx.parsed.y.toLocaleString(),
        },
      },
    },
    scales: {
      x: {
        grid: { color: 'rgba(0,0,0,0.06)' },
        ticks: { color: '#232950', font: { size: 11 } },
      },
      y: {
        grid: { color: 'rgba(0,0,0,0.06)' },
        ticks: {
          color: '#232950',
          font: { size: 11 },
          callback: (v) => 'KSh ' + v.toLocaleString(),
        },
      },
    },
  };

  return (
    <>
      <div className="container-fluid p-4">

        {/* Header */}
        <div>
          <h3>
            Fadlan wixii cabasho, Cillad iyo Tala bixin ah nagula wadaag{' '}
            <button
              className="btn btn-info"
              style={{ marginBottom: '10px' }}
              onClick={() => window.open('https://portal.kaafi.net/login/portal-login')}
            >
              Halkaan
            </button>{' '}
            Mahadsanid
          </h3>
        </div>
        <br />
        <h2>Dashboard</h2>

        {/* Detail Modal */}
        {selectedId && (
          <DetailData
            token={token}
            id={selectedId}
            route="get-chart-detail"
            title={chartTitle}
            isOpen={isModalOpen}
            onRequestClose={closeModal}
          />
        )}

        {/* Stat Cards */}
        <div className="row">
          {stats &&
            stats.length > 0 &&
            stats.map((stat, index) => (
              <div
                className="col-12 col-sm-6 col-md-3 mb-3"
                key={index}
                onClick={() => openModal(stat.id, stat.title)}
                style={{ cursor: 'pointer' }}
              >
                <div className={`card text-white bg-${stat.bg_color} h-100`}>
                  <div className="card-body d-flex flex-column">
                    <FeatherIcon icon={stat.icon} />
                    <h4 className="card-title mt-3">{t(stat.title)}</h4>
                    <p className="card-text h5">{stat.value}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* Bar Chart - Sales by Product */}
        {isSamaCompany && (
        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3">Sales by Product - {getMonthTitle()}</h5>
                {loadingChart ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : salesData ? (
                  <div style={{ position: 'relative', height: '320px' }}>
                    <Bar data={salesData} options={barOptions} />
                  </div>
                ) : (
                  <div className="text-center text-muted py-5">
                    No data available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      </div>

      {isAllowedAPI && isAllowedUser && <CustomerCareDashboard />}
      {isAllowedAPI && userType === 'customer' && <CustomerPortalDashbpard />}
    </>
  );
}